import { Component, NgZone, OnInit } from '@angular/core';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { MyProgram } from '@app/models/system/my-program.model';
import { getMyPrograms, MyProgramState } from '@app/selectors/system/my-program.selector';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { loadCompany } from '../../actions/system/company.actions';
import { Company } from '../../models/system/company.model';
import { CompanyState, getCompany } from '../../selectors/system/company.selector'
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { SmWownetState, getSmWownet } from '@app/selectors/system/sm-wownet.selector';
import { ValidationUtil } from '@app/common/util/validation.util';
import { AuthUtil } from '@app/common/util/auth.util';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { setWAlert } from '@app/actions/w-alert.action';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { MessageConstant } from '@app/common/constant/message.constant';
import { ConvertUtil } from '@app/common/util/convert.util';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { CartState, getCartInfo, getCountCart } from '@app/selectors/shoppingmall/cart.selector';
import { ActionConstant } from '@app/common/constant/action-constant';
import { CommonConstant } from '@app/common/constant/common.constant';

declare const backToTop: any;
declare const swiper: any;

@Component({
  selector: 'hp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  company$ = new Observable<Company>();

  cartLength$ = new Observable<Number>();

  smWownet$ = new Observable<SmWownetModel>;
  smWownet: any = {} as SmWownetModel;

  cartInfo$ = new Observable<OrderMstModel[]>();
  cartInfo: OrderMstModel[] = {} as OrderMstModel[];

  isLogin: boolean = AuthUtil.isLogined();

  footerMenu: MyProgram[] = [];
  sidebarMenu: MyProgram[] = [];
  pdtRecent: OrdPdtModel[] = [];

  urlWownet: string = "";
  cate: string = '';

  cartLength: number = 0;
  cartLengthNotLogin: number = 0;

  constructor(
    private _companyStore: Store<CompanyState>,
    private _myProgramStore: Store<MyProgramState>,
    private _smWownetStateStore: Store<SmWownetState>,
    private _router: Router,
    private _wAlertStore: Store<WAlertState>,
    private _activatedRoute: ActivatedRoute,
    private ngZone: NgZone, 
    private _cartStore: Store<CartState>
  ) {
    this.smWownet$ = this._smWownetStateStore.select(getSmWownet); 
    this.company$ = this._companyStore.select(getCompany);
    this.cartInfo$ = this._cartStore.select(getCartInfo);
    this.cartLength$ = this._cartStore.select(getCountCart);
  }
  
  ngOnInit(): void {  
    this._companyStore.dispatch(loadCompany());

    this._myProgramStore.select(getMyPrograms).subscribe(res => {
      this.footerMenu = res.filter(y => y.prgKind == MyProgramConstant.kindMenuFooter);
      this.sidebarMenu = res.filter(y => y.prgKind == MyProgramConstant.kindSidebar);
    });

    this.smWownet$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.smWownet = res;
        this.urlWownet = res.urlWownet;
      }
    });

    let cardInfoTmp: any = sessionStorage.getItem("cardInfoTmp");
    let linkCart: any = sessionStorage.getItem("linkCart");
    if(ValidationUtil.isNotNullAndNotEmpty(cardInfoTmp) || ValidationUtil.isNotNullAndNotEmpty(linkCart)) {
      this.cartLengthNotLogin = 1;
    } else {
      this.cartLengthNotLogin = 0;
    }

    window.addEventListener('storage', () => {
      this.ngZone.run(() => {
        let pdtClickRecent: any = localStorage.getItem("pdtClickRecent");
        if(ValidationUtil.isNotNullAndNotEmpty(pdtClickRecent)) {
          this.pdtRecent = JSON.parse(pdtClickRecent);
          setTimeout(() => {
            swiper();
          }, 500);
        };

        let cardInfoTmp: any = sessionStorage.getItem("cardInfoTmp");
        let linkCart: any = sessionStorage.getItem("linkCart");
        if(ValidationUtil.isNotNullAndNotEmpty(cardInfoTmp) || ValidationUtil.isNotNullAndNotEmpty(linkCart)) {
          this.cartLengthNotLogin = 1;
        } else {
          this.cartLengthNotLogin = 0;
        }
      });
    });

    let pdtClickRecent: any = localStorage.getItem("pdtClickRecent");
    if(ValidationUtil.isNotNullAndNotEmpty(pdtClickRecent)){
      this.pdtRecent = JSON.parse(pdtClickRecent);
      setTimeout(() => {
        swiper();
      }, 500);
    };

    this._activatedRoute.queryParamMap.subscribe(params => {
      this.cate = ConvertUtil.convertToSring(params.get("cate"));
    });

    this.cartLength$.subscribe(res => {
      this.cartLength = res.valueOf();
    });

    this.cartInfo$.subscribe(res => {
      this.cartInfo = res;
    });
  }

  handleOnClickBackToTop(): void {
    if(typeof backToTop === "function") {
      backToTop();
    }
  }

  handleOnClickProductDetail(item: OrdPdtModel): void {
    switch(this.isLogin) {
      case false:
        if(this.smWownet.lShowPdtYn === CommonConstant.NO) {
          this.showAlertRequiredLogin();
        } else {
          if(item.cateNameOrg == 'PROMOTION' || item.cateNameOrg == 'JOINT' || item.cateNameOrg == 'POINT' || item.cateNameOrg == 'SUBSCRIPTION') {
            this.showAlertRequiredLogin();
          } else {
            window.location.href = MyProgramConstant.urlShopping + `/product/${item.pdtCd}`;
          }
        }
        break;
      case true:
        if(!ValidationUtil.isNotNullAndNotEmpty(this.cate)) {
          this.cate = '*';
        }
        window.location.href = MyProgramConstant.urlShopping + `/product/${item.pdtCd}`;
        break;  
      default:
        this.showAlertRequiredLogin();
        break;
    }
  }

  showAlertRequiredLogin(): void {
    this._wAlertStore.dispatch(
      setWAlert({ 
        wAlert: { 
          icon: WAlertConstant.confirm, 
          message: MessageConstant.msgRequiredLogin, 
          action: ActionConstant.actionConfirmLogined 
        } 
      })
    );
  }

  handleClickToCart() {
    if(this.isLogin) {
      this._router.navigateByUrl(MyProgramConstant.urlShopping + `/page-list-cart`);
    } else {
      this._router.navigateByUrl( MyProgramConstant.urlShopping + `/cart`);
    }    
  }

  handleAlert() {
    alert("준비중입니다.");
  }
}
